/**
 * StaffCustomersHub — IT-SCE Intern: "Kunden"-Sektion mit Sub-Tabs.
 *
 * TQ #9694 (Staff-Migration Teil A, Bundle #9523, ZIELBILD-Unified-Cockpit).
 * Bündelt StaffCustomers + StaffOrganizations unter der Route /staff/customers
 * (Sidebar-Link "Kunden", Layout.tsx Zeile 359-362) — mirrort das
 * StaffCustomersHub-Muster aus customer-portal/src/pages/staff/
 * StaffHubPages.tsx, aber bewusst nur auf die 2 Teil-A-Seiten skaliert
 * (VMs/Tokens/Tenant-Onboarding sind NICHT Teil dieses Tasks).
 *
 * Routing: /staff/customers und /staff/organizations rendern beide diesen
 * Hub (App.tsx); der aktive Tab wird aus dem Pfad abgeleitet, ein Tab-Klick
 * navigiert (kein Reload, kein Datenverlust der jeweils anderen Seite außer
 * beim erneuten Fetch — Precedent identisch zu customer-portal).
 */

import { useLocation, useNavigate } from 'react-router-dom'
import StaffCustomers from './StaffCustomers'
import StaffOrganizations from './StaffOrganizations'

interface Tab {
  id: string
  label: string
  icon: string
  path: string
}

const TABS: Tab[] = [
  { id: 'customers', label: 'Kunden', icon: '👥', path: '/staff/customers' },
  { id: 'organizations', label: 'Organisationen', icon: '🏛️', path: '/staff/organizations' },
]

export default function StaffCustomersHub() {
  const navigate = useNavigate()
  const path = useLocation().pathname
  const active = path.includes('/organizations') ? 'organizations' : 'customers'

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: '2rem 1.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
        <a href="/" style={{ color: '#FF6B35', textDecoration: 'none', fontSize: '0.9rem' }}>
          ← Cockpit
        </a>
      </div>
      <h1 style={{ margin: 0, fontSize: '1.6rem' }}>👥 Kunden &amp; Organisationen</h1>

      <nav style={{ display: 'flex', gap: 4, marginTop: '1rem', marginBottom: '1.5rem', borderBottom: '1px solid #e5e7eb' }} role="tablist">
        {TABS.map(t => (
          <button
            key={t.id}
            role="tab"
            aria-selected={active === t.id}
            onClick={() => navigate(t.path)}
            style={{
              padding: '0.6rem 1rem',
              border: 'none',
              borderBottom: active === t.id ? '2px solid #FF6B35' : '2px solid transparent',
              background: 'none',
              color: active === t.id ? '#FF6B35' : '#374151',
              fontWeight: active === t.id ? 600 : 400,
              cursor: 'pointer',
              fontSize: '0.95rem',
            }}
          >
            <span aria-hidden>{t.icon}</span> {t.label}
          </button>
        ))}
      </nav>

      <div role="tabpanel">
        {active === 'customers' && <StaffCustomers />}
        {active === 'organizations' && <StaffOrganizations />}
      </div>
    </div>
  )
}
